import { RawDraftContentState } from 'draft-js';
import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { GenerateReportModal } from '../../shared/report/GenerateReportModal';
import { generateReportStarted, getGenerateModalOpen, getReportEmailBody, getReportSelectedUserIds, getReportTemplateDescription, getReportTemplateName, getReportUpdated, getSelectedTemplateId, toggleGenerateModalOpen, updateReportTemplateValue } from './store';

export const GenerateDocumentReportModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(getGenerateModalOpen);
    const templateName = useAppSelector(getReportTemplateName);
    const templateDescription = useAppSelector(getReportTemplateDescription);
    const templateId = useAppSelector(getSelectedTemplateId);
    const selectedUserIds = useAppSelector(getReportSelectedUserIds);
    const emailBody = useAppSelector(getReportEmailBody);
    const reportHasUpdated = useAppSelector(getReportUpdated);

    const closeModal = useCallback(() => dispatch(toggleGenerateModalOpen(false)), [dispatch]);
    const generateReport = useCallback((shouldDownload: boolean, shouldEmail: boolean, shouldSave: boolean, shouldSaveAs: boolean) => dispatch(generateReportStarted(shouldDownload, shouldEmail, shouldSave, shouldSaveAs)), [dispatch]);
    const updateReportValue = useCallback((key: 'templateName' | 'templateDescription' | 'templateUserIds' | 'templateEmailBody', value: string | number[] | RawDraftContentState | null) => dispatch(updateReportTemplateValue(key, value)), [dispatch]);

    return (
        <GenerateReportModal
            isOpen={isOpen}
            closeModal={closeModal}
            reportHasUpdated={reportHasUpdated}
            generateReport={generateReport}
            updateReportValue={updateReportValue}
            templateName={templateName}
            templateDescription={templateDescription}
            selectedUserIds={selectedUserIds}
            emailBody={emailBody}
            templateId={templateId}
            testId='document'
        />
    );
};
